
import React, { useState, useEffect, useRef } from "react";
import { Dialog, Button, TextField, CircularProgress } from "@mui/material";
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";

function MediaUploadDialog({
  isOpen,
  type, // "image" | "audio" | "emoji"
  onSubmit,
  onCancel,
  loading = false,
  title,
  confirmLabel,
  chooseLabel,
  width,
  height,
}) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [caption, setCaption] = useState("");
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setSelectedFile(null);
      setCaption("");
    }
  }, [isOpen]);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    //  ---- FOR IMAGE VALIDATION  ----
    if (type === "image") {
      const allowedImageTypes = ["image/jpeg", "image/png"];

      if (!allowedImageTypes.includes(file.type)) {
        alert("Invalid image format. Allowed: .jpeg, .png");
        return;
      }

      if (file.size > 2 * 1024 * 1024) {
        alert("Image file size must be less than 2MB");
        return;
      }
    }

    // --- FOR AUDIO VALIDATION --- 
    if (type === "audio") {
      const allowedAudioTypes = [
        "audio/aac",
        "audio/amr",
        "audio/mp3",
        "audio/mpeg",
        "audio/x-m4a",
        "audio/mp4"
      ];

      if (!allowedAudioTypes.includes(file.type)) {
        alert("Invalid audio format. Allowed: .aac, .amr, .mp3, .m4a");
        return;
      }

      if (file.size > 10 * 1024 * 1024) {
        alert("Audio file size must be less than 10MB");
        return;
      }
    }

    setSelectedFile(file);
  };

  const handleChooseClick = () => {
    fileInputRef.current?.click();
  };

  const handleEmojiSelect = (emoji) => {
    onSubmit(emoji);
  };

  const handleSubmit = () => {
    if (type === "image") {
      onSubmit(selectedFile, caption);
    } else if (type === "audio") {
      onSubmit(selectedFile);
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onCancel}
      // maxWidth="xs"
      // fullWidth
      PaperProps={{
        sx: {
          width: width,
          height: height,
          maxHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        },
      }}  >

      <div
        style={{
          padding: 24,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 16,
          overflowY: "auto",
        }}
      >
        {/* <Typography variant="h6">{title}</Typography> */}
        <h3 style={{ fontSize: 20, fontWeight: 500, margin: 0 }}>
          {title}
        </h3>

        {(type === "image" || type === "audio") && (
          <>
            <input
              ref={fileInputRef}
              accept={
                type === "image"
                  ? "image/jpeg,image/png"
                  : "audio/aac,audio/amr,audio/mpeg,audio/mp4,audio/x-m4a"
              }
              type="file"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />

            {/* Choose Button for choose image or audio  */}
            <Button variant="outlined" onClick={handleChooseClick}>
              {chooseLabel}
            </Button>
          </>
        )}

        {/* Preview */}
        {selectedFile && type === "image" && (
          <>
            <div
              style={{
                marginTop: 16,
                marginBottom: 16,
                overflow: "hidden",
                display: "flex",
                justifyContent: "center",
              }}>
              <img
                src={URL.createObjectURL(selectedFile)}
                alt="preview"
                style={{
                  maxHeight: "25vh",
                  width: "auto",
                  maxWidth: "100%",
                  objectFit: "contain",
                  borderRadius: 8,
                }} />
            </div>
            <TextField
              label="Add a caption"
              value={caption}
              onChange={(e) => setCaption(e.target.value)}
              fullWidth
              size="small"
              multiline
              maxRows={3}
            />
          </>
        )}

        {selectedFile && type === "audio" && (
          <div style={{ marginTop: 16, marginBottom: 16, textAlign: "center" }}>
            <audio
              controls
              src={URL.createObjectURL(selectedFile)}
              style={{ width: 200 }}
            />
          </div>

        )}

        {type === "emoji" && (
          <Picker
            data={data}
            onEmojiSelect={handleEmojiSelect}
            // theme="dark"
            showPreview={false}
            showSkinTones={false}
          />
        )}

        {/* for cancel and send image or audio button*/}
        {(type === "image" || type === "audio") && (
          <div
            style={{
              display: "flex",
              gap: 8,
              marginTop: 16,
              justifyContent: "center",
            }}
          >
            <Button onClick={onCancel} disabled={loading}> Cancel</Button>
            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={!selectedFile || loading}
            >
              {loading ? <CircularProgress size={20} /> : confirmLabel}
            </Button>
          </div>
        )}
      </div>
    </Dialog>
  );
}

export default MediaUploadDialog;
